import { createAction, props } from '@ngrx/store';

export const setDropdownValue = createAction(
  '[Dropdown] Set Dropdown Value',
  props<{ value: string }>()
);
